import { render, staticRenderFns } from "./BetaRelease.vue?vue&type=template&id=f9aaf2ee&scoped=true"
import script from "./BetaRelease.vue?vue&type=script&lang=js"
export * from "./BetaRelease.vue?vue&type=script&lang=js"
import style0 from "./BetaRelease.vue?vue&type=style&index=0&id=f9aaf2ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9aaf2ee",
  null
  
)

export default component.exports